import roleAccess from './role-access'
import user from './user'
import credentialManagement from './credentialManagement'
import helpCenter from './help-center'

export default [...roleAccess, ...user, ...credentialManagement, ...helpCenter]
